import React from 'react';
import {Link} from 'react-router-dom';
import Icon from 'shared/components/icon';

interface BannerProps {
  dismiss: () => void;
  message: string;
  link: string;
  linkPath: string;
  linkHandler?: () => void;
}

const Banner: React.FC<BannerProps> = ({dismiss, message, link, linkPath, linkHandler}) => (
  <div className="banner-message">
    <div className="banner-message-content">
      {message}
      <Link className="banner-message-link" to={linkPath} onClick={linkHandler}>
        {link}
      </Link>
      <button className="close-banner" type="button" aria-label="Close banner" onClick={dismiss}>
        <Icon iconType="times-r" />
      </button>
    </div>
  </div>
);

export default Banner;
